/* 
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
*/

import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import ICButton from "../../components/button";
import ICInput from "../../components/form/input";
import Label from "../../components/label";
import { useHistory } from "react-router-dom";
import appRoutes from "../../routes/appRoutes";
import ICCheckbox from "../../components/form/checkbox";

const ViewAppointment = props => {
  const history = useHistory();

  // For picture
  //   const [attachmentFile, setattachmentFile] = React.useState(null);

  const formik = useFormik({
    initialValues: {
      bookingNumber: "100155",
      dateReceived: "10-08-2019",
      contactName: "Open Booking",
      contactNumber: "0401 20 043",
      patientUIN: "112421",
      patientName: "Ruby Rose",
      clinicUIN: "",
      clinicName: "",
      billableTo: "Patient",
      natureOfConsult: "Cosmetic Injectables Form",
      bookingDate: "26-08-2019",
      bookingTime: "4:00 PM",
      fracgpOnly: false,
      bookingStatus: "Open",
      practioner: "",
      practionerName: "",
      notes: "Open Booking"
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      props.onFormSubmit(values);
    }
  });

  const goBack = () => {
    history.push(
      props.backNav ? appRoutes.openAppointments : appRoutes.myAppointments
    );
  };

  return (
    <form className="w-100 mt-4" onSubmit={formik.handleSubmit}>
      <div className="row">
        <div className="col-sm-12">
          <Label
            title="Booking Number:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="bookingNumber"
            name="bookingNumber"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bookingNumber}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Date Received:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="dateReceived"
            name="dateReceived"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.dateReceived}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Contact Name:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="contactName"
            name="contactName"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder="First"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.contactName}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Contact Number:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="contactNumber"
            name="contactNumber"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.contactNumber}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Patient UIN:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="patientUIN"
            name="patientUIN"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.patientUIN}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Patient Name:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="patientName"
            name="patientName"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.patientName}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Clinic UIN:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="clinicUIN"
            name="clinicUIN"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.clinicUIN}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Clinic Name:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="clinicName"
            name="clinicName"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.clinicName}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Billable to:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="billableTo"
            name="billableTo"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.billableTo}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Nature of Consult:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="natureOfConsult"
            name="natureOfConsult"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.natureOfConsult}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Booking Date:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="bookingDate"
            name="bookingDate"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bookingDate}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Booking Time:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="bookingTime"
            name="bookingTime"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bookingTime}
            disabled
          />
          <Label
            className="gray small ml-5 pt-0 mt-0"
            title="(this is Brisbane time - remember to account for your timezone and daylight savings)"
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12 custom-chk-lbl">
          <Label
            title="FRACGP/FACRRM Only:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICCheckbox
            name="fracgpOnly"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.fracgpOnly}
            inputProps={{ "aria-label": "" }}
            label=""
            className="ml-5"
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Status:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="bookingStatus"
            name="bookingStatus"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.bookingStatus}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Practitioner Booked:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="practioner"
            name="practioner"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder="Search Practitioners Record"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.practioner}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Practitioner Name:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="practionerName"
            name="practionerName"
            label=""
            className="w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.practionerName}
            disabled
          />
        </div>
      </div>

      <div className="row mt-3">
        <div className="col-sm-12">
          <Label
            title="Notes:"
            required={true}
            className="gray small float-left custom-label-width"
          />
          <ICInput
            id="notes"
            name="notes"
            label=""
            className="text-area w-50 ml-5 pt-1"
            placeholder=""
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.notes}
            multiline
            rows={6}
            disabled
          />
        </div>
      </div>

      {/* Enable below div for no attachment found */}
      {/* <div className="row mt-3">
        <div className="col-sm-4 offset-sm-3">
          <Label
            title="No attachments available"
            className="gray float-left w-100"
          />
        </div>
      </div> */}

      <div className="row mt-4">
        <div className="col-sm-12 text-center">
          <ICButton
            className="gray-outline ml-0"
            title="Back"
            clickEvent={goBack}
          />
        </div>
      </div>
    </form>
  );
};

export default ViewAppointment;
